import React, { useState, useEffect } from 'react';
import RecipientCheckboxes from './RecipientCheckboxes';
import { Cureus } from '../../Cureus';


const AuthorsReminderModal = (props) => {
  const [recipients, setRecipients] = useState([]);
  const [subject, setSubject] = useState(props.data.subject || '');
  const [message, setMessage] = useState(props.data.message || '');

  useEffect(() => {
    autoCheckAssignedAdmins()
  }, []);

  const autoCheckAssignedAdmins = () => {
    let assignedAdmins = props.data.usersData.map( (admin) => {
      if (admin.isAssignedToArticle == true) {
        return admin.email
      }
    })
    let removeUndefined = assignedAdmins.filter(item => item);
    setRecipients(removeUndefined);
  }

  const handleSubmit = () => {
    const { createPath } = props;

    $("#form-submit-button").addClass('disabled');

    const payload = {
      templateName: props.templateName,
      templateData: {
        recipientAuthorshipIds: recipients.map(recipient => recipient.authorshipId),
        subject: subject,
        message: message,
        article_id: props.data.articleId
      }
    };

    $.ajax({
      type: "POST",
      url: createPath,
      dataType: "json",
      contentType: "application/json",
      data: JSON.stringify(payload),
      success: () => {
        $('#email-reminder-modal').foundation('reveal', 'close');
        Cureus.Flash.success("Success! You've sent a reminder to the user.");
      },
      error: () => {
        $('#email-reminder-modal').foundation('reveal', 'close');
        Cureus.Flash.alert("Oops! There was an error with your request.");
      },
    });
  };

  const renderSubmitButton = () => {
    if (props.async) {
      return (
        <a className='button primary' id="form-submit-button" onClick={handleSubmit}>Send</a>
      );
    } else {
      return (
        <input type='submit' value='Send' className='button primary'/>
      );
    }
  };

  const handleSelectAdmin = (e) => {
    const recipient = JSON.parse(e.target.value);
    const recipientsClone = recipients.slice();

    if (isAlreadyAdded(recipientsClone, recipient)) {
      let excludedRecipients = excludeRecipient(recipientsClone, recipient);
      setRecipients(excludedRecipients);
    } else {
      recipientsClone.push(recipient);
      setRecipients(recipientsClone);
    }
  }

  const excludeRecipient = (recipients, recipient) => {
    return recipients.filter(
      r => !(r.email === recipient.email && r.articleId === recipient.articleId)
    );
  }

  const handleSelectAll = (e) => {
    e.preventDefault();
    setRecipients(props.data.usersData);
  }

  const isAlreadyAdded = (recipients, recipient) => {
    return recipients.some(r => r.email === recipient.email && r.articleId === recipient.articleId);
  }

  const recipientEmails = () => {
    return recipients.map(recipient => recipient.email).join(', ');
  }

  return (
    <div className="reveal-modal small" data-reveal id="email-reminder-modal">
      <div className="modal-body">
        <div className="modal-close">
          <a className="cancel-modal">
            <img alt="Close_x" src="https://public.cureus.com/close_x.png"/>
          </a>
        </div>

        <div className="modal-content">
          <form id="reminder-form">

            <RecipientCheckboxes
              recipientType={"authors"}
              users={props.data.usersData}
              handleSelectAdmin={handleSelectAdmin}
              recipients={recipients}
            />

            <button onClick={handleSelectAll} className="button primary small select-all">Select All</button>

            <label>Recipients</label>
            <input type='text' value={recipientEmails()} readOnly/>

            <label>From</label>
            <input type='text' value={props.data.from} readOnly/>

            <label>Subject</label>
            <input type='text' value={subject} onChange={(e) => setSubject(e.target.value)} />

            <label>Message</label>
            <textarea className="large-text-pizzas" value={message} onChange={(e) => setMessage(e.target.value)} rows='8' />

            <div className='modal-footer'>
              <a className='cancel-modal button secondary'>Cancel</a>
              {renderSubmitButton()}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AuthorsReminderModal;
